<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
            class="nav-link"
            @click="toggleVerticalMenuActive"
        >
          <feather-icon
              icon="MenuIcon"
              size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">

      <template v-if="$store.state.user.redirectFrom">

        <b-alert
            show
            variant="primary"
        >
          <div class="alert-body">
            <feather-icon
                class="mr-25"
                icon="StarIcon"
            />
            <span class="ml-25"
            >شما از دسترسی <strong>{{ $store.state.user.redirectFrom.name }}</strong> وارد شدید.</span>
            <b-button
                size="sm"
                variant="primary"
                @click="backToMain"
            >
              بازگشت
            </b-button>
          </div>
        </b-alert>
      </template>
      <!--      &lt;!&ndash; Bookmarks Container &ndash;&gt;-->
      <!--      <bookmarks />-->
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <!--      <locale />-->
      <dark-Toggler class="d-none d-lg-block"/>
      <!--      <search-bar />-->
      <!--      <cart-dropdown />-->
      <!--      <notification-dropdown />-->
      <Ticket-notification></Ticket-notification>
      <Task-notification></Task-notification>
      <Request-Notification></Request-Notification>
      <Room-Reservation-Notification></Room-Reservation-Notification>

      <user-dropdown/>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BAlert, BButton
} from 'bootstrap-vue'
import Bookmarks from './components/Bookmarks.vue'
import Locale from './components/Locale.vue'
import SearchBar from './components/SearchBar.vue'
import DarkToggler from './components/DarkToggler.vue'
import CartDropdown from './components/CartDropdown.vue'
import NotificationDropdown from './components/NotificationDropdown.vue'
import TicketNotification from './components/TicketNavBar.vue'
import UserDropdown from './components/UserDropdown.vue'
import TaskNotification from '@core/layouts/components/app-navbar/components/TaskNavBar.vue'
import RequestNotification from '@core/layouts/components/app-navbar/components/RequestNavBar.vue'
import RoomReservationNotification from "@core/layouts/components/app-navbar/components/RoomReservationNavBar.vue";

export default {
  components: {
    TaskNotification,
    BLink,

    // Navbar Components
    BNavbarNav,
    Bookmarks,
    Locale,
    SearchBar,
    DarkToggler,
    CartDropdown,
    NotificationDropdown,
    TicketNotification,
    RequestNotification,
    RoomReservationNotification,
    UserDropdown,
    BAlert,
    BButton
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {
      },
    },
  },
  methods: {
    backToMain() {
      this.$http.post(`user/back-to-user/${this.$store.state.user.redirectFrom.token}`)
          .then((data) => {
            this.$store.commit('user/UPDATE_USER_DATA', data.user)
            this.$store.commit('user/UPDATE_USER_REDIRECT_FROM', data.redirect_from)
            this.$router.replace({ name: 'reloadPage' })
            // window.location.reload()
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? error.message, {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    }
  }
}
</script>
